import React, { useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import './novaconta.css';
import logoSmall from './../../comum/assets/arbor.png';

import firebase from '../Config/firebase';
import 'firebase/compat/auth';

import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';

function NovaConta() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  
  const senhaRef = useRef(null);
  const navigate = useNavigate();

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  function cadastrarUsuario() {
    setMensagem('');
    if (!email || !senha) {
      setMensagem('Informe todos os campos');
      return;
    }

    firebase.auth().createUserWithEmailAndPassword(email, senha).then(resultado => {
      setSucesso('S');
      navigate('/restaurante');
    }).catch(error => {  
      setSucesso('N');    
      if (error.message === 'Password should be at least 6 characters') {
        setMensagem('A senha deve ter pelo menos 6 caracteres');
      } else if (error.message === 'The email address is badly formatted.') {
        setMensagem('O e-mail não é válido');
      }
      else if (error.message === 'The email address is already in use by another account.') {
        setMensagem('Esse e-mail já está em uso por outra conta');
      }
      else {
        setMensagem('Erro ao criar conta: ' + error.message);
      }
    });
  }

  return (
    <div className="d-flex flex-column vh-100 overflow-hidden">
      <Menu modulo="RESTAURANTE" />
      <div className="form-container">
        <form className="form-signin" onSubmit={(e) => e.preventDefault()}>
          <img className="img-login" src={logoSmall} alt="Arbor Web" />

          <div className="form-floating">
            <input 
              onChange={(e) => setEmail(e.target.value)} 
              type="email" 
              className="form-control" 
              id="floatingInput" 
              placeholder="E-mail" 
              value={email}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  senhaRef.current?.focus();
                }
              }}
            />
            <label htmlFor="floatingInput">E-mail</label>
          </div>

          <div className="form-floating">
            <input 
              onChange={(e) => setSenha(e.target.value)} 
              type={showPassword ? "text" : "password"} 
              className="form-control" 
              id="floatingPassword" 
              placeholder="Senha" 
              ref={senhaRef}
              value={senha}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  cadastrarUsuario();
                }
              }}
            />
            <label htmlFor="floatingPassword">Senha</label>
            <button
              type="button"
              className="btn-eye-toggle"
              onClick={toggleShowPassword}
              tabIndex="-1"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          
          <button 
            onClick={cadastrarUsuario} 
            className="w-100 btn btn-login-restaurante" 
            type="button"
          >
            Criar Conta
          </button>

          {mensagem.length > 0 && (
            <div className="alert alert-danger mt-3 py-2 px-3 small rounded-3 text-center" role="alert">
              {mensagem}
            </div>
          )}

          <div className="login-links">
            <Link to="/restaurante/login" className="link-restaurante">
              Já tenho uma conta
            </Link>
          </div>

          <p className="text-copyright text-center">
            &copy; Desenvolvido por F2 Enterprise
          </p>
        </form>
      </div>
      <Footer />
    </div>
  );
}

export default NovaConta;